module.exports = __webpack_public_path__ + "img/angststoerungen_960.a8db5d62.webp";